import store from '../store';

const menuList = [{
	path: 'project',
	meta: {
		name: '项目列表',
		menu: 'project',
		role: '5'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/project/project_list')
	}, {
		path: 'detail',
		meta: {
			name: '项目详情'
		},
		component: () => import('@/pages/project/project_detail'),
		props: route => route.query
	}]
}, {
	path: 'bidding',
	meta: {
		name: '中标项目',
		menu: 'project',
		role: '7'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/project/bidding_list')
	}, {
		path: 'create',
		meta: {
			name: '新建中标项目'
		},
		component: () => import('@/pages/project/bidding_create')
	}]
}, {
	path: 'supervision',
	meta: {
		name: '监理项目',
		menu: 'project',
		role: '8'
	},
	component: () => import('@/pages/project/supervision_list')
}, {
	path: 'person_change',
	meta: {
		name: '项目人员变更',
		menu: 'project',
		role: '7,8'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/project/person_change')
	}, {
		path: 'apply',
		meta: {
			name: '申请项目人员变更'
		},
		component: () => import('@/pages/project/person_change_apply'),
		props: route => route.query
	}, {
		path: 'edit',
		meta: {
			name: '编辑项目人员变更'
		},
		component: () => import('@/pages/project/person_change_apply'),
		props: route => route.query
	}, {
		path: 'detail',
		meta: {
			name: '项目人员变更详情'
		},
		component: () => import('@/pages/project/person_change_detail'),
		props: route => route.query
	}]
}, {
	path: 'insurance',
	meta: {
		name: '保单管理',
		menu: 'insurance',
		role: '7'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/insurance/insurance_list')
	}, {
		path: 'apply',
		meta: {
			name: '保险办理'
		},
		component: () => import('@/pages/insurance/insurance_apply'),
		props: route => route.query
	}, {
		path: 'datum',
		meta: {
			name: '完善保单资料'
		},
		component: () => import('@/pages/insurance/insurance_datum'),
		props: route => route.query
	}, {
		path: 'detail',
		meta: {
			name: '保单详情'
		},
		component: () => import('@/pages/insurance/insurance_detail'),
		props: route => route.query
	}]
}, {
	path: 'order_approve',
	meta: {
		name: '待审批订单',
		menu: 'order',
		role: '3'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/order/order_approve')
	}]
}, {
	path: 'order_list',
	meta: {
		name: '历史订单',
		menu: 'order',
		role: '3'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/order/order_list')
	}]
}, {
	path: 'order_chart',
	meta: {
		name: '订单量化图',
		menu: 'order',
		role: '3'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/order/order_chart')
	}]
}, {
	path: 'proceed',
	meta: {
		name: '开工令管理',
		menu: 'proceed',
		role: '7,8'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/proceed/proceed_list')
	}, {
		path: 'apply',
		meta: {
			name: '申请开工令'
		},
		component: () => import('@/pages/proceed/proceed_apply')
	}, {
		path: 'edit',
		meta: {
			name: '编辑开工令'
		},
		component: () => import('@/pages/proceed/proceed_apply'),
		props: route => route.query
	}, {
		path: 'detail',
		meta: {
			name: '开工令详情'
		},
		component: () => import('@/pages/proceed/proceed_detail'),
		props: route => route.query
	}]
}, {
	path: 'contract',
	meta: {
		name: '合同管理',
		menu: 'contract',
		role: '7'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/contract/contract_list')
	}, {
		path: 'detail',
		meta: {
			name: '合同详情'
		},
		component: () => import('@/pages/contract/contract_detail'),
		props: route => route.query
	}]
}, {
	path: 'ledger',
	meta: {
		name: '安全台账管理',
		menu: 'ledger',
		role: '7,8'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/ledger/ledger_list')
	}, {
		path: 'detail',
		meta: {
			name: '安全台账详情'
		},
		component: () => import('@/pages/ledger/ledger_detail'),
		props: route => route.query
	}]
}, {
	path: 'claim_approve',
	meta: {
		name: '待处理理赔',
		menu: 'claim',
		role: '3,6'
	},
	component: () => import('@/pages/claim/claim_approve')
}, {
	path: 'claim',
	meta: {
		name: '理赔记录',
		menu: 'claim',
		role: '3,6'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/claim/claim_list')
	}, {
		path: 'detail',
		meta: {
			name: '理赔详情'
		},
		component: () => import('@/pages/claim/claim_detail'),
		props: route => route.query
	}]
}, {
	path: 'message',
	meta: {
		name: '消息中心',
		menu: 'message'
	},
	component: () => import('@/pages/message/index')
}, {
	path: 'user',
	meta: {
		name: '账号信息',
		menu: 'user'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/user/user_info')
	}, {
		path: 'edit',
		meta: {
			name: '编辑账号信息'
		},
		component: () => import('@/pages/user/user_info_edit')
	}]
}];

const pageList = [{
	path: '/',
	component: () => import('@/pages/home/index')
}, {
	path: '/login',
	meta: {
		title: '登录'
	},
	component: () => import('@/pages/login/index')
}, {
	path: '/tacs_sso/callback',
	meta: {
		title: '统一认证登录'
	},
	component: () => import('@/pages/login/tacs_sso_callback')
}, {
	path: '/register',
	meta: {
		name: '完善资料'
	},
	component: () => import('@/pages/user/user_info_edit'),
	props: {
		register: true
	}
}, {
	path: '/transact',
	meta: {
		name: '业务办理'
	},
	component: () => import('@/pages/blank'),
	children: menuList
}, {
	path: '/notice',
	meta: {
		name: '政策通知'
	},
	component: () => import('@/pages/blank'),
	children: [{
		path: '',
		component: () => import('@/pages/notice/index')
	}, {
		path: 'detail',
		component: () => import('@/pages/notice/detail'),
		props: route => route.query
	}]
}, {
	path: '/manual',
	meta: {
		name: '操作手册'
	},
	component: () => import('@/pages/manual/index')
}, {
	path: '*',
	redirect: '/'
}];

let counter = 0;
!function loop(list) {
	list.forEach(item => {
		if (!item.meta) {
			item.meta = {};
		}
		item.meta.id = '2002207516' + (counter < 10 ? '0' + counter : counter);
		counter++;
		item.children && loop(item.children);
	});
}(pageList.concat(menuList));

export default pageList

export {menuList}

export let menuGroup = {
	project: {
		name: '项目管理',
		icon: 'tf-menu-project'
	},
	
	insurance: {
		icon: 'tf-menu-insurance'
	},
	
	proceed: {
		icon: 'tf-menu-proceed'
	},
	
	contract: {
		icon: 'tf-menu-contract'
	},
	
	ledger: {
		icon: 'tf-menu-ledger'
	},
	
	order: {
		name: '保函订单',
		icon: 'tf-menu-order'
	},
	
	claim: {
		name: '理赔管理',
		icon: 'tf-menu-claim'
	},
	
	message: {
		icon: 'tf-menu-message'
	},
	
	user: {
		icon: 'tf-menu-user'
	}
}